/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React from 'react';

import {CommonErrors} from '../../../../constants/Common';
import {sortBy} from '../../../../shared/commonFunctions';
import {AverageKey, AverageLabel} from '../../Constants/IP/AverageKeyLabel';
import {filterSelectOptions} from '../commonFunctions';

const CapGoodsSupplierSpec: React.FC<{
  supplier: any;
  name?: any;
  mainName?: string;
}> = ({supplier, name, mainName}) => {
  const tableCol = 24;
  const {getFieldValue} = useFormInstance();

  const supplierFilter = (value: any) => {
    return supplier.filter((item: any) => {
      return !getFieldValue(mainName)?.some((tableItem: any) => {
        return value
          ? tableItem?.[AverageKey.SUPPLIER_NAME] === item?.value &&
              value !== item.value
          : tableItem?.[AverageKey.SUPPLIER_NAME] === item?.value;
      });
    });
  };

  return (
    <>
      <Col className="gutter-row" span={tableCol}>
        <Form.Item
          name={[name, AverageKey.SUPPLIER_NAME]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(AverageLabel.SUPPLIER_NAME)
            }
          ]}
          label={AverageLabel.SUPPLIER_NAME}
          labelCol={{span: 24}}
        >
          <Select
            showSearch
            className="select"
            placeholder={`Choose ${AverageLabel.SUPPLIER_NAME}`}
            filterOption={filterSelectOptions}
            options={sortBy(
              supplierFilter(
                getFieldValue([mainName, name, AverageKey.SUPPLIER_NAME])
              ),
              'label',
              'asc'
            )}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default CapGoodsSupplierSpec;
